<template>
 <el-tabs class="common-tabs" v-model="activeName" @tab-click="handleTabClick">
  <el-tab-pane label="数据上传" name="tabUpload">
  <!--历史上传记录-->
  <div id="myUpHistoryRecord">
    <div class="allBody">
      <nav class="allTop">
        <div> {{fileName}}历史上传记录</div>
         <span @click="$commonJs.backURL" class="btn-back">
          <span>返回</span>
        </span>
      </nav>
      <div>
        <div class="allDl m_t_20">
          <dl class="allDl_width25 allDl_span80">
            <dd style="width: 40%">
              <span>上传时间:</span>
              <div class="d_flex" style="display: inline-flex">
                <div style="width: 45%">
                  <cander v-model="postData.start" :className="'allInput'" :newWidth="'100%'"></cander>
                </div>
                <div class="t_c" style="width: 40px">至</div>
                <div style="width: 45%">
                  <cander
                    :minDate="postData.start"
                    v-model="postData.end"
                    :className="'allInput'"
                    :newWidth="'100%'"
                  ></cander>
                </div>
              </div>
            </dd>
            <dd>
              <span class="t_r">状态:</span>
              <div>
                <allSelect
                  v-model="postData.status"
                  :chooseData="upHistoryList"
                  :needReturn="'id'"
                  :matchValue="'name'"
                  :showValue="'{{name}}'"
                  :width="'100%'"
                  :placeholder="'全部'"
                  :borderLine="'#E5E5E5'"
                ></allSelect>
              </div>
            </dd>
            <dt>
              <button @click="getAllList(1)" class="suerButton">
                <i class="icon iconfont iconsousuo" style="font-size: 14px"></i>
                <span class="m_l_5">搜索</span>
              </button>
            </dt>
          </dl>
        </div>
        <div style="max-height: calc(100vh - 230px);overflow: auto">
          <table class="allTable" cellspacing="0">
            <thead>
              <tr>
                <th>文件名</th>
                <th>上传时间</th>
                <th>上传人</th>
                <th>文件大小</th>
                <th>状态</th>
                <th>备注信息</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="index" v-for="(item, index) in myAllList">
                <td>
                  <span
                    class="NoWrap dis_line"
                    style="max-width: 300px"
                    :title="item.remark"
                  >{{ item.fileName }}</span>
                </td>
                <td>{{ item.createTime }}</td>
                <td>{{ item.createName }}</td>
                <td>{{item.fileSize}}</td>
                <td>
                  <span
                    :class="returnSwitch(item.uploadTaskStatus, 2)"
                  >{{returnSwitch(item.uploadTaskStatus, 1)}}</span>
                </td>
                <td>
                  <span
                    class="NoWrap dis_line"
                    style="max-width: 240px"
                    :title="item.remark"
                  >{{item.remark}}</span>
                </td>
                <td class="colorYellowF36A20" width="80">
                  <div class="d_flex">
                    <span
                      v-if="parseInt(item.uploadTaskStatus) === 5 && item.isActive && item.isEnableUpload"
                      @click="greenFieldMode(item, false)"
                      class="c_p"
                    >停用</span>
                    <span
                      v-if="parseInt(item.uploadTaskStatus) === 6 && item.isActive && item.isEnableUpload"
                      @click="greenFieldMode(item, true)"
                      class="c_p"
                    >启用</span>
                    <!--<span v-if="(parseInt(item.uploadTaskStatus) === 5 || parseInt(item.uploadTaskStatus) === 6) && item.coverId === 0 && item.isEnableDownload" @click="confirmExport(item)" class="c_p">导出</span>-->
                    <span
                      v-if="(parseInt(item.uploadTaskStatus) === 5 || parseInt(item.uploadTaskStatus) === 6) && item.isEnableDownload"
                      @click="confirmExport(item)"
                      class="c_p"
                    >导出</span>
                    <span
                      v-if="parseInt(item.uploadTaskStatus) === 4 && item.isHasErrorDetail"
                      @click="toUrl(item)"
                      class="c_p"
                    >查看详情</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <page
          :totalCount="totalCount"
          v-if="totalPage !== 0"
          v-on:on-getList="getAllList($event)"
          :totalPage="totalPage"
          :page="page"
          :numPage="1"
        ></page>
      </div>
    </div>
    <model
      v-if="showModel4"
      :title="'正在下载'"
      :minWidth="'60%'"
      :showClose="1"
      :onButton="0"
      v-on:on-cancel="showModel3 = false"
    >
      <div class="pd_10_20">
        <div class="filrProgNum" style="margin: auto">
          <p class="d_flex">
            <span>{{ upName }}</span>
            <span class="colorGray9D9D9D">{{ uploadMdoel }}%</span>
          </p>
          <div class="m_t_5 m_b_5">
            <div :style="{'width': uploadMdoel + '%'}"></div>
          </div>
        </div>
      </div>
    </model>
  </div></el-tab-pane>
  <el-tab-pane label="数据下载" name="tabDown"></el-tab-pane>
  <el-tab-pane label="系统管理" name="tabSystem"></el-tab-pane>
</el-tabs>
</template>

<script>
export default {
  name: 'myUpHistoryRecord',
  data () {
    return {
      activeName: 'tabUpload',
      showModel4: false,
      uploadMdoel: 0,
      upName: '',
      // source: this.$axiox.CancelToken.source()
      formId: parseInt(this.$route.query.formId),
      fileName: JSON.parse(JSON.stringify(localStorage.formHomeFileName)) || '',
      totalPage: 0,
      totalCount: 0,
      page: 1,
      postData: {
        start: '',
        end: '',
        status: 0,
        ItemId: 0,
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || 10
      },
      myAllList: [],
      upHistoryList: [
        {
          id: 0,
          name: '全部'
        },
        {
          id: 1,
          name: '校验中'
        },
        {
          id: 2,
          name: '上传失败'
        },
        {
          id: 3,
          name: '上传成功'
        },
        {
          id: 4,
          name: '停用'
        }
      ]
    }
  },
  created () {
    this.getAllList(1)
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    handleTabClick () {
      if (this.activeName === 'tabDown') {
        this.$router.push({name: 'myDnload'})
      } else if (this.activeName === 'tabSystem') {
        this.$router.push({name: 'mySystemMessager'})
      }
    },
    returnSwitch (type, num) {
      switch (parseInt(type)) {
        case 1:
          return num === 1 ? '待校验' : 'colorYellowFFB800'
        case 2:
          return num === 1 ? '待处理' : 'colorYellowFFB800'
        case 3:
          return num === 1 ? '处理中' : 'colorYellowFFB800'
        case 4:
          return num === 1 ? '上传失败' : 'colorRedEB0000'
        case 5:
          return num === 1 ? '上传成功' : 'colorGreen00B828'
        case 6:
          return num === 1 ? '停用' : 'colorRedEB0000'
      }
      return ''
    },
    getAllList (page) {
      let data = JSON.parse(JSON.stringify(this.postData))
      data.PageIndex = page
      data.ItemId = this.formId
      let url = this.$commonJs.returnQuery('/api/File/HistoryQuery', data)
      this.$axiox.get(url).then(msg => {
        this.myAllList = msg.datas || []
        this.page = page
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    },
    toUrl (item) {
      this.$commonJs.addLog('查看错误日志', '数据上传', '', item.fileName)
      this.$router.push({
        name: 'myErrorMessageList',
        query: {
          formId: item.id
        }
      })
      localStorage.upHistName = item.fileName
    },
    greenFieldMode (item, type) {
      let operation = type ? '启用' : '停用'
      this.$commonJs.addLog(operation, '数据上传', '', item.fileName)
      this.$axiox.get('/api/File/UpdateStatus?id=' + item.id + '&isactive=' + type).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '操作成功',
          stayTime: 5
        })
        this.getAllList(this.page)
      })
    },
    //  下载
    confirmExport (item) {
      let that = this
      that.$commonJs.addLog('导出', '数据上传', '', item.fileName)
      let url = ''
      that.uploadMdoel = 0
      var xmlResquest = new XMLHttpRequest()
      url = this.$baseUrlConfig.baseUrl + '/api/File/DownLoad?hisid=' + item.id
      xmlResquest.open('GET', url, true)
      xmlResquest.onprogress = function (e) {
        var percent = e.loaded / e.total
        that.uploadMdoel = parseInt(percent * 100)// progress 在data中定义的全局变量，显示的进度
        // console.log(that.uploadPercent)
        that.upName = item.fileName
        that.showModel4 = true
      }
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.localStorage.getItem('gskToken'))
      xmlResquest.setRequestHeader('Ocp-Apim-Subscription-Key', this.$baseUrlConfig.ocpKey)
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        if (content.type) {
          if (content.type.indexOf('json') >= 0) {
            that.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '暂无数据',
              stayTime: 5
            })
            that.showModel4 = false
            return
          }
        }
        var elink = document.createElement('a')
        elink.download = item.fileName
        elink.style.display = 'none'
        var blob = new Blob([content])
        if (that.$IENum === 11) {
          window.navigator.msSaveOrOpenBlob(blob, name + '.xls')
        } else {
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          document.body.removeChild(elink)
        }
        that.showModel4 = false
      }
      xmlResquest.send()
    }
  }
}
</script>

<style scoped>
.allTop > div{position:relative;}
.allTop .btn-back{
  position:absolute;
  right:30px;top:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/myHome/myUpHistoryRecord.vue